export default __webpack_public_path__ + "static/media/Add-Address.729a12fd.jpg";